const listaDePrazosContratuais = (state) => {
    if (!state.items || !Array.isArray(state.items)) {
        return [];
    }
    return state.items;
}

const loadingPrazosContratuais = (state) => {
    return state.carregando
}

export {
    listaDePrazosContratuais,
    loadingPrazosContratuais
}
